import React, { useState, useEffect } from "react";
import "../../styles/Investers.css";
import PersonelDetails from "../../components/Admin/PersonalDetails";
import BankDetails from "../../components/Admin/BankDetails";
import FatchDeclaration from "../../components/Admin/FatchDeclaration";
import ManageNominess from "../../components/Admin/ManageNominess";
import { IoMdClose } from "react-icons/io";
import { FaCircleCheck } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  AddInvestor,
  UpdateInvestor,
  InvestorAddFormData,
  InvestorEditFormData,
  InvestorDetail,
} from "../../actions/adminAction";
import { useFormik } from "formik";
import * as Yup from "yup";
import { sanitizeInput } from "../../utils/sanitizeInput";
import { toast } from "react-toastify";
import { INVESTOR_RESET } from "../../actions/types";
import Loader from "../../loader/Loader-ui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";

const AddInvestorForm = () => {
  const investorData =
    useSelector((state) => state.admin.adminEditInvestorData?.data) || {};
  const dispatch = useDispatch(); // Initialize dispatch
  const navigate = useNavigate();
  const location = useLocation();
  const investorId = location.state;
  const [isLoading, setIsLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(1); // State to track the current step
  const totalSteps = 4; // Total number of steps
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isEditing = Boolean(investorId);
  const [noNominee, setNoNominee] = useState("N");
  const [soaNominee, setSoaNominee] = useState("N");
  const [nomineeCount, setNomineeCount] = useState(
    investorData?.user?.customers?.no_of_nominees || 1
  );

  const fetchInvestorList = async () => {
    try {
      setIsLoading(true);
      await dispatch(InvestorEditFormData(investorId));
    } catch (error) {
      console.error("Error fetching investor:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch existing data if editing
  useEffect(() => {
    if (isEditing) {
      fetchInvestorList();
    } else {
      dispatch({ type: INVESTOR_RESET }); // Dispatch an action to reset FAQ detail data
    }
  }, [dispatch, investorId]);

  useEffect(() => {
    if (investorData?.user?.customers?.no_of_nominees != null) {
      setNomineeCount( investorData?.user?.customers?.no_of_nominees
      );
    }
    if (investorData?.user?.customers?.nominee_soa) {
      setSoaNominee(investorData.user?.customers.nominee_soa);
    }
    if (investorData?.user?.customers?.nomination_opt != null) {
      setNoNominee(
        investorData.user?.customers.nomination_opt == true ? "Y" : "N"
      );
    }
  }, [investorData]);
  // Initial Values for Formik
  const initialValues = {
    // Personal Information
    userId: isEditing
      ? investorData?.user?.customers?.user_id?.toString() || ""
      : "", // Only for edit
    primary_holder_first_name:
      investorData?.user?.customers?.primary_holder_first_name?.trim() || "",
    primary_holder_pan: investorData?.user?.customers?.primary_holder_pan || "",
    primary_holder_dob_incorporation: investorData?.user?.customers
      ?.primary_holder_dob_incorporation
      ? moment(
          investorData.user.customers.primary_holder_dob_incorporation
        ).format("DD-MM-YYYY")
      : "",
    // adhaar_card: investorData?.profile?.adhaar_card || "",
    indian_mobile_no: investorData?.user?.mobile || "",
    email: investorData?.user?.customers?.email || "",
    indian_mobile_no: investorData?.user?.mobile || "",
    // email: investorData?.user?.customers?.email || "",
    // mobile_relation: investorData?.profile?.mobile_relation || "",
    // email_relation: investorData?.profile?.email_relation || "",
    gender: investorData?.user?.customers?.gender || "",
    // marital_status: investorData?.user?.customers?.marital_status || "",
    primary_holder_middle_name:
      investorData?.user?.customers?.primary_holder_middle_name?.trim() || "",
    primary_holder_last_name:
      investorData?.user?.customers?.primary_holder_last_name?.trim() || "",
    occupation_code: investorData?.user?.customers?.occupation_code || "",
    address_1: investorData?.user?.customers?.address_1?.trim() || "",
    pincode: investorData?.user?.customers?.pincode || "",
    city: investorData?.user?.customers?.city?.trim() || "",
    state: investorData?.user?.customers?.state?.trim() || "",
    nationality: investorData?.user?.customers?.nationality?.trim() || "INDIAN",

    // NRI Address (Nullable)
    nri_addr1: investorData?.nri_addr1 || "",
    nri_city: investorData?.nri_city || "",
    nri_pincode: investorData?.nri_pincode || "",
    nri_state: investorData?.nri_state || "",
    nri_country: investorData?.nri_country || "",

    // Bank Details
    bank_id: isEditing ? investorData?.userBank?.id || "" : "", // Only for edit
    acc_no: investorData?.userBank?.acc_no?.toString() || "",
    acc_no_confirm: investorData?.userBank?.acc_no?.toString() || "",
    bank_holder_name: investorData?.userBank?.bank_holder_name?.trim() || "", // Assuming account holder is investor
    acc_type: investorData?.userBank?.acc_type || "",
    ifsc_code: investorData?.userBank?.ifsc_code || "",
    bank_code: investorData?.userBank?.bank_code || "",
    branch_name: investorData?.userBank?.branch_name?.trim() || "",
    branch_pincode: investorData?.userBank?.branch_pincode || "",
    branch_addr1: investorData?.userBank?.branch_addr1?.trim() || "",
    branch_city: investorData?.userBank?.branch_city?.trim() || "",
    file_attachment: investorData?.user?.cheque_image || "",
    set_default: investorData?.userBank?.set_default || "Y",

    // FATCA & Financial Info
    annual_income: investorData?.fatca?.annual_income || "",
    address_type: investorData?.fatca?.address_type || "",
    source_of_wealth: investorData?.fatca?.source_of_wealth || "",
    birth_place: investorData?.fatca?.birth_place?.trim() || "",
    tax_residency: investorData?.fatca?.tax_residency || "N",
    tax_status: "01",
    tax_payer_identityno1: investorData?.fatca?.tax_payer_identityno1 || "",
    id1_type: investorData?.fatca?.id1_type || "C",
    // id1_type: investorData?.fatca?.id1_type || "C",
    // id_no: investorData?.fatca?.id_no || "",
    // idtype: investorData?.fatca?.idtype || "",

    // Nominee Details (Up to 3)
    nominee_1_name: investorData?.user?.customers?.nominee_1_name?.trim() || "",
    nominee_1_relationship:
      investorData?.user?.customers?.nominee_1_relationship || "",
    nominee_1_dob: investorData?.user?.customers?.nominee_1_dob
      ? moment(investorData.user.customers.nominee_1_dob).format("DD-MM-YYYY")
      : "",
    nominee_1_applicable: investorData?.user?.customers?.nominee_1_applicable
      ? parseFloat(investorData?.user?.customers?.nominee_1_applicable).toFixed(
          2
        )
      : 0 || "",
    nominee_1_pan: investorData?.user?.customers?.nominee_1_pan || "",
    nominee_1_guard_name:
      investorData?.user?.customers?.nominee_1_guardian?.trim() || "",
    nominee_1_guard_pan:
      investorData?.user?.customers?.nominee_1_guardian_pan || "",
    nominee_1_guardian_relation:
      investorData?.user?.customers?.nominee_1_guardian_relation || "",
    nominee_1_identity_type:
      investorData?.user?.customers?.nominee_1_identity_type || "1",
    nominee_1_identity_no:
      investorData?.user?.customers?.nominee_1_identity_number || "",
    nominee_1_email: investorData?.user?.customers?.nominee_1_email || "",
    nominee_1_mobile: investorData?.user?.customers?.nominee_1_mobile || "",
    nominee_1_address1:
      investorData?.user?.customers?.nominee_1_address1
        ?.replace(/\s+/g, " ")
        .trim() || "",
    nominee_1_address2:
      investorData?.user?.customers?.nominee_1_address2
        ?.replace(/\s+/g, " ")
        .trim() || "",
    nominee_1_city: investorData?.user?.customers?.nominee_1_city?.trim() || "",
    nominee_1_pin: investorData?.user?.customers?.nominee_1_pin || "",
    nominee_1_state:
      investorData?.user?.customers?.nominee_1_state?.trim() || "",
    nominee_1_country:
      investorData?.user?.customers?.nominee_1_country?.trim() || "",

    nominee_2_name: investorData?.user?.customers?.nominee_2_name?.trim() || "",
    nominee_2_relationship:
      investorData?.user?.customers?.nominee_2_relationship || "",
    nominee_2_dob: investorData?.user?.customers?.nominee_2_dob
      ? moment(investorData.user.customers.nominee_2_dob).format("DD-MM-YYYY")
      : "",
    nominee_2_applicable: investorData?.user?.customers?.nominee_2_applicable
      ? parseFloat(investorData?.user?.customers?.nominee_2_applicable).toFixed(
          2
        )
      : 0 || "",
    nominee_2_pan: investorData?.user?.customers?.nominee_2_pan || "",
    nominee_2_guard_name:
      investorData?.user?.customers?.nominee2_guard_name?.trim() || "",
    nominee_2_guard_pan:
      investorData?.user?.customers?.nominee2_guard_pan || "",
    nominee_2_identity_type:
      investorData?.user?.customers?.nominee_2_identity_type || "1",
    nominee_2_identity_no:
      investorData?.user?.customers?.nominee_2_identity_number || "",
    nominee_2_email: investorData?.user?.customers?.nominee_2_email || "",
    nominee_2_mobile: investorData?.user?.customers?.nominee_2_mobile || "",
    nominee_2_address1:
      investorData?.user?.customers?.nominee_2_address1
        ?.replace(/\s+/g, " ")
        .trim() || "",
    nominee_2_address2:
      investorData?.user?.customers?.nominee_2_address2
        ?.replace(/\s+/g, " ")
        .trim() || "",
    nominee_2_city: investorData?.user?.customers?.nominee_2_city?.trim() || "",
    nominee_2_pin: investorData?.user?.customers?.nominee_2_pin || "",
    nominee_2_state: investorData?.user?.customers?.nominee_2_state || "",
    nominee_2_country:
      investorData?.user?.customers?.nominee_2_country?.trim() || "",
    nominee_2_guardian_relation:
      investorData?.user?.customers?.nom2_guardian_relation || "",

    nominee_3_name: investorData?.user?.customers?.nominee_3_name?.trim() || "",
    nominee_3_relationship:
      investorData?.user?.customers?.nominee_3_relationship || "",
    nominee_3_dob: investorData?.user?.customers?.nominee_3_dob
      ? moment(investorData.user.customers.nominee_3_dob).format("DD-MM-YYYY")
      : "",
    nominee_3_applicable: investorData?.user?.customers?.nominee_3_applicable
      ? parseFloat(investorData?.user?.customers?.nominee_3_applicable).toFixed(
          2
        )
      : 0 || "",
    nominee_3_pan: investorData?.user?.customers?.nominee_3_pan || "",
    nominee_3_guard_name:
      investorData?.user?.customers?.nominee_3_guardian?.trim() || "",
    nominee_3_guard_pan:
      investorData?.user?.customers?.nominee_3_guardian_pan || "",
    nominee_3_guardian_relation:
      investorData?.user?.customers?.nominee_3_guardian_relation || "",
    nominee_3_identity_type:
      investorData?.user?.customers?.nominee_3_identity_type || "1",
    nominee_3_identity_no:
      investorData?.user?.customers?.nominee_3_identity_number || "",
    nominee_3_email: investorData?.user?.customers?.nominee_3_email || "",
    nominee_3_mobile: investorData?.user?.customers?.nominee_3_mobile || "",
    nominee_3_address1:
      investorData?.user?.customers?.nominee_3_address1
        ?.replace(/\s+/g, " ")
        .trim() || "",
    nominee_3_address2:
      investorData?.user?.customers?.nominee_3_address2
        ?.replace(/\s+/g, " ")
        .trim() || "",
    nominee_3_city: investorData?.user?.customers?.nominee_3_city?.trim() || "",
    nominee_3_pin: investorData?.user?.customers?.nominee_3_pin || "",
    nominee_3_state: investorData?.user?.customers?.nominee_3_state || "",
    nominee_3_country:
      investorData?.user?.customers?.nominee_3_country?.trim() || "",
    nominee_soa: investorData?.user?.customers?.nominee_soa || "N",
  };

  const parseDate = (input) => {
    console.log("inputinput111", input);
    if (!input || input == undefined) return null;

    // Check if input is ISO format
    if (input.includes("T")) {
      const date = new Date(input);
      return isNaN(date.getTime()) ? null : date;
    }

    // Assume format is DD-MM-YYYY
    const [day, month, year] = input.split("-").map(Number);
    if (!day || !month || !year) return null;

    return new Date(year, month - 1, day); // month is 0-indexed
  };

  const calculateAge = (dob) => {
    const birthDate = parseDate(dob?.[0]);
    if (!birthDate) return null;

    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  const sanitizeTest = (fieldName) => ({
    name: `is-sanitized-${fieldName}`,
    test: (value) => {
      const sanitizedValue = sanitizeInput(value);
      return sanitizedValue === value; // Ensure input matches sanitized output
    },
    message: `Input should be sanitized, and no action should occur`,
  });

  // Dynamic Validation Schema for Each Step
  const validationSchemas = [
    // Step 1: Personal Details
    Yup.object().shape({
      primary_holder_first_name: Yup.string()
        .transform((value) => (value ? value.trim() : value))
        .matches(/^[A-Za-z\s]+$/, "First Name must contain only alphabets")
        .required("First Name is required"),
      primary_holder_dob_incorporation: Yup.string().required(
        "Date of Birth is required"
      ),
      email: Yup.string()
        .email("Enter a valid email address")
        .required("Email is required"),
      // email_relation: Yup.string()
      //   .notOneOf(["Select"], "Email Belongs To is required")
      //   .required("Email Belongs To is required"),
      // mobile: Yup.string()
      //   .matches(/^[6-9]\d{9}$/, "Must be 10 digits")
      //   .required("Mobile Number is required"),
      // mobile_relation: Yup.string()
      //   .notOneOf(["Select"], "Mobile Belongs To is required")
      //   .required("Mobile Belongs To is required"),
      gender: Yup.string().required("Gender is required"),
      // marital_status: Yup.string().required("Marital Status is required"),
      // primary_holder_middle_name: Yup.string()
      //   .transform((value) => (value ? value.trim() : value))
      //   .matches(/^[A-Za-z\s]+$/, "Parent Name must contain only alphabets")
      //   .required("Parent Name is required"),
      primary_holder_last_name: Yup.string()
        .transform((value) => (value ? value.trim() : value))
        .matches(/^[A-Za-z\s]+$/, "Last Name must contain only alphabets")
        .required("Last Name is required"),
      occupation_code: Yup.string()
        .notOneOf(["Select"], "Occupation is required")
        .required("Occupation is required"),
      primary_holder_pan: Yup.string()
        .matches(
          /^[A-Z]{5}[0-9]{4}[A-Z]$/,
          "Invalid PAN format (e.g., ABCDE1234F)"
        )
        .required("PAN is required"),
      indian_mobile_no: Yup.string()
        .matches(
          /^[6-9]\d{9}$/,
          "Invalid mobile number (must be 10 digits starting with 6-9)"
        )
        .required("Mobile number is required"),
      // adhaar_card: Yup.string()
      //   .matches(/^\d{12}$/, "Must be 12 digits")
      //   .required("Aadhar is required"),
      address_1: Yup.string()
        .transform((value) => (value ? value.trim() : value))
        .max(200, "Max 200 characters")
        .required("Address is required"),
      pincode: Yup.string()
        .matches(/^\d{6}$/, "Must be 6 digits")
        .required("Pincode is required"),
      city: Yup.string()
        .transform((value) => (value ? value.trim() : value))
        .required("City is required"),
      state: Yup.string()
        .notOneOf(["Select"], "State is required")
        .required("State is required"),
    }),
    // Step 2: Bank Details
    Yup.object().shape({
      acc_no: Yup.string()
        .matches(/^\d+$/, "Account number must contain only numbers")
        .min(8, "Account number must be at least 8 digits")
        .max(16, "Account number must not exceed 16 digits")
        .required("Account number is required"),
      acc_no_confirm: Yup.string()
        .matches(/^\d+$/, "Account number must contain only numbers")
        .min(8, "Account number must be at least 8 digits")
        .max(16, "Account number must not exceed 16 digits")
        .required("Confirm Account Number is required")
        .oneOf([Yup.ref("acc_no")], "Account numbers do not match"),
      bank_holder_name: Yup.string()
        .trim()
        .matches(/^[A-Za-z\s]+$/, "Invalid Account Holder Name format")
        .required("Account Holder Name is required"),
      acc_type: Yup.string()
        .notOneOf(["Select"], "Account Type is required")
        .required("Account Type is required"),
      ifsc_code: Yup.string()
        .required("IFSC Code is required")
        .matches(
          /^[A-Za-z]{4}0[A-Za-z0-9]{6}$/,
          "Invalid IFSC code, should follow format XXXX0XXXXXX"
        ),
      bank_code: Yup.string()
        .notOneOf(["Select"], "Bank Name is required")
        .required("Bank Name is required"),
      branch_name: Yup.string()
        .transform((value) => (value ? value.trim() : value))
        .required("Branch Name is required"),
      branch_addr1: Yup.string()
        .transform((value) => value.replace(/\s{2,}/g, " "))
        .test(sanitizeTest("Branch Address"))
        .max(119, "Input should not accept more than 119 characters")
        .required("Branch Address is required"),
      // branch_city: Yup.string()
      //   .required("Branch City is required"),
      file_attachment: Yup.mixed()
        .required("Cancelled Cheque is required")
        .test("fileType", "Only PDF or image files are allowed", (value) => {
          if (!value) return false; // Ensure the value exists

          if (typeof value === "string") {
            // Handle file as a link
            const allowedExtensions = /\.(pdf|jpg|jpeg|png)$/i;
            return allowedExtensions.test(value);
          } else if (value instanceof File) {
            // Handle file as a File object
            const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
            return allowedTypes.includes(value.type);
          }

          return false;
        })
        .test("fileSize", "File size must be less than 2MB", (value) => {
          if (value instanceof File) {
            return value.size <= 2 * 1024 * 1024; // 2MB in bytes
          }
          return true; // Skip size check if it's a string (link)
        }),
      // file_attachment: Yup.mixed()
      // .required("Cancelled Cheque is required")
      // .test("fileType", "Only PDF or image files are allowed", (value) => {
      //   if (!value) return false; // Ensure the value exists
      //   if (typeof value === "string") {
      //     // Handle file as a link
      //     const allowedExtensions = /\.(pdf|jpg|jpeg|png)$/i;
      //     return allowedExtensions.test(value);
      //   } else if (value instanceof File) {
      //     // Handle file as a File object
      //     const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
      //     return allowedTypes.includes(value.type);
      //   }
      //   return false;
      // }),
      // file_attachment: Yup.mixed()
      // .required("Cancelled Cheque is required")
      // .test("fileType", "Only PDF or image files are allowed", (value) => {
      //   if (!value) return false;

      //   // Case 1: It's a string URL (from backend)
      //   if (typeof value === "string") {
      //     const allowedExtensions = /\.(pdf|jpg|jpeg|png)$/i;
      //     return allowedExtensions.test(value);
      //   }

      //   // Case 2: It's a File object
      //   if (value instanceof File) {
      //     const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
      //     return allowedTypes.includes(value.type);
      //   }

      //   // ✅ Case 3: It's a base64-wrapped object
      //   if (typeof value === "object" && value.type && value.data) {
      //     const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
      //     return allowedTypes.includes(value.type);
      //   }

      //   return false;
      // }),
    }),

    // Step 3: FATCA Declaration (Updated)
    Yup.object().shape({
      // pan: Yup.string()
      //   .matches(/^[A-Z]{5}[0-9]{4}[A-Z]$/, "Invalid PAN format (e.g., ABCDE1234F)")
      //   .required("PAN is required"),
      annual_income: Yup.string()
        .notOneOf(["Select"], "Annual Income is required")
        .required("Annual Income is required"),
      address_type: Yup.string()
        .notOneOf(["Select"], "Address Type is required")
        .required("Address Type is required"),
      source_of_wealth: Yup.string()
        .notOneOf(["Select"], "Source of Income is required")
        .required("Source of Income is required"),
      birth_place: Yup.string()
        .transform((value) => (value ? value.trim() : value))
        .test(sanitizeTest("Birth Place"))
        .max(100, "Input should not accept more than 100 characters")
        .required("Birth Place is required")
        .matches(/^[A-Za-z\s]+$/, "Only alphabets allowed"),
      tax_status: Yup.string().required("Tax Status is required"),
      id1_type: Yup.string().required("ID Type is required"),
      tax_payer_identityno1: Yup.string().required("ID Number is required"),
      // idtype: Yup.string()
      //   .notOneOf(["Select"], "ID Type is required")
      //   .required("ID Type is required"),
      // id_no: Yup.string().required("ID Number is required"),
      // tax_residency: Yup.string().required("Tax Residency is required"),
    }),
    // Step 4: Nominees (Updated Validation)
    noNominee === "Y"
      ? Yup.object({}) // Skip validation when no nominee selected
      : Yup.object().shape(
          [...Array(nomineeCount)].reduce((acc, _, index) => {
            const i = index + 1;
            const prefix = `nominee_${i}`;
            const address1Key = `${prefix}_address1`;

            acc[`${prefix}_name`] = Yup.string()
              .required("Nominee name is required")
              .matches(
                /^[A-Za-z]+(?:\s[A-Za-z]+)*$/,
                "Name must contain only alphabets"
              );

            acc[`${prefix}_relationship`] = Yup.string()
              .required("Nominee relation is required")
              .notOneOf(["Select"], "Relation is required");

            acc[`${prefix}_dob`] = Yup.string().required(
              "Date of birth is required"
            );

            acc[`${prefix}_applicable`] = Yup.number()
              .required(`Nominee percentage is ${i} required`)
              .min(1, "Must be at least 1%")
              .max(100, "Cannot exceed 100%");

            // Guardian validation if age < 18
            acc[`${prefix}_guardian`] = Yup.string().when(
              `${prefix}_dob`,
              (dob, schema) => {
                if (!dob) return schema.notRequired(); // <--- Guard for empty DOB
                const age = calculateAge(dob);
                return age < 18
                  ? schema
                      .required("Guardian name is required for minors")
                      .matches(
                        /^[A-Za-z\s]+$/,
                        "Guardian Name must contain only alphabets"
                      )
                  : schema.notRequired();
              }
            );

            acc[`${prefix}_guardian_pan`] = Yup.string().when(
              `${prefix}_dob`,
              (dob, schema) => {
                if (!dob) return schema.notRequired(); // <--- Guard for empty DOB
                const age = calculateAge(dob);
                const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
                return age < 18
                  ? schema
                      .required("Guardian PAN is required for minors")
                      .matches(
                        panRegex,
                        "Invalid PAN format (e.g., ABCDE1234F)"
                      )
                  : schema.notRequired();
              }
            );

            acc[`${prefix}_identity_type`] = Yup.string().when(
              `${prefix}_dob`,
              (dob, schema) => {
                if (!dob) return schema.notRequired(); // <--- Guard for empty DOB
                const age = calculateAge(dob);
                return age >= 18
                  ? schema.required("ID Type is required")
                  : schema.notRequired();
              }
            );

            acc[`${prefix}_identity_no`] = Yup.string().when(
              [`${prefix}_dob`, `${prefix}_identity_type`],
              ([dob, idType], schema) => {
                if (!dob || !idType) return schema.notRequired(); // <--- Guard for empty DOB or ID type
                const age = calculateAge(dob);
                if (age < 18) return schema.notRequired();

                switch (idType) {
                  case "1":
                    return schema
                      .required("PAN number is required")
                      .matches(
                        /^[A-Z]{5}[0-9]{4}[A-Z]$/,
                        "Invalid PAN format (e.g., ABCDE1234F)"
                      );
                  case "2":
                    return schema
                      .required("Aadhaar last 4 digits are required")
                      .matches(/^\d{4}$/, "Enter last 4 digits of Aadhaar");
                  case "3":
                    return schema
                      .required("Driving Licence number is required")
                      .matches(
                        /^[A-Z]{2}\d{2}\s?\d{11}$/,
                        "Invalid Driving Licence format"
                      );
                  case "4":
                    return schema
                      .required("Passport number is required")
                      .matches(
                        /^[A-PR-WY][0-9]{7}$/,
                        "Invalid Passport format (e.g., A1234567)"
                      );
                  default:
                    return schema.required("Nominee Id Number is required");
                }
              }
            );

            acc[`${prefix}_email`] = Yup.string()
              .required("Nominee Email is required")
              .email("Enter a valid email address");

            acc[`${prefix}_mobile`] = Yup.string()
              .required("Nominee Mobile Number is required")
              .matches(/^[6-9]\d{9}$/, "Mobile number must be 10 digits");

            acc[address1Key] = Yup.string()
              .transform((value) => (value ? value.trim() : value))
              .required("Nominee Address is required")
              .max(40, "Max 40 characters");

            acc[`${prefix}_pin`] = Yup.string()
              .required("Nominee Pincode is required")
              .matches(/^\d{6}$/, "Pincode must be 6 digits");

            acc[`${prefix}_city`] = Yup.string()
              .transform((value) => (value ? value.trim() : value))
              .required("Nominee City is required");

            return acc;
          }, {})
        ),
  ];

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchemas[currentStep - 1], // Adjust the index to match the step.
    onSubmit: async (values) => {
      // Loop through form values and append to FormData
      const formData = new FormData();

      for (const key in values) {
        if (key === "file_attachment") {
          if (values[key] instanceof File) {
            formData.append("cheque_file", values[key]);
          }
        } else {
          formData.append(key, values[key]);
        }
      }

      // ✅ Add noNominee manually if it's set to "Y"
      // if (noNominee === "Y") {
      //   formData.append("noNominee", "Y");
      // }
      if (noNominee === "Y") {
        // ✅ Set noNominee flag
        formData.append("noNominee", "Y");

        // ✅ Set all nominee-related fields to null or defaults
        const nullNomineeFields = {
          no_of_nominees: 0,
          // nominee1_type: "",
          nominee_1_name: "",
          nominee_1_dob: "",
          nominee_1_address1: "",
          nominee_1_address2: "",
          nominee_1_city: "",
          nominee_1_state: "",
          nominee_1_pin: "",
          nominee_1_relationship: "",
          nominee_1_applicable: 0,
          nominee_1_guardian: "",
          nominee_1_guardian_pan: "",
          nominee_1_identity_type: "",
          nominee_1_identity_number: "",
          nominee_1_email: "",
          nominee_1_mobile: "",
          nominee_1_country: "",

          nominee_2_name: "",
          nominee_2_dob: "",
          nominee_2_address1: "",
          nominee_2_address2: "",
          nominee_2_city: "",
          nominee_2_state: "",
          nominee_2_pin: "",
          nominee_2_relationship: "",
          nominee_2_applicable: 0,
          nominee_2_guardian: "",
          nominee_2_guardian_pan: "",
          nominee_2_identity_type: "",
          nominee_2_identity_number: "",
          nominee_2_email: "",
          nominee_2_mobile: "",
          nominee_2_country: "",

          nominee_3_name: "",
          nominee_3_dob: "",
          nominee_3_address1: "",
          nominee_3_address2: "",
          nominee_3_city: "",
          nominee_3_state: "",
          nominee_3_pin: "",
          nominee_3_relationship: "",
          nominee_3_applicable: 0,
          nominee_3_guardian: "",
          nominee_3_guardian_pan: "",
          nominee_3_identity_type: "",
          nominee_3_identity_number: "",
          nominee_3_email: "",
          nominee_3_mobile: "",
          nominee_3_country: "",

          nominee_opted: "N",
          nominee_soa: "N",
        };

        // ✅ Overwrite values to null/defaults
        Object.entries(nullNomineeFields).forEach(([key, val]) => {
          formData.set(key, val); // .set() replaces if already exists
        });
      }

      // ✅ Nominee % validation (only when noNominee !== "Y")
      if (noNominee !== "Y") {
        let totalPercent = 0;

        for (let i = 1; i <= nomineeCount; i++) {
          const key = `nominee_${i}_applicable`;
          const val = values[key] ? parseFloat(values[key]) : 0;
          console.log("val", val);
          totalPercent += val;
          console.log("totalPercenttotalPercent", totalPercent);
        }

        if (totalPercent !== 100) {
          toast.error("Total nominee percentage must equal 100%");
          return; // 🛑 Prevent API call if validation fails
        }
      }

      // Clean and set branch_addr1
      formData.set(
        "branch_addr1",
        values?.branch_addr1?.replace(/\s{2,}/g, " ").trim() || ""
      );
      let response;
      if (isEditing) {
        response = await dispatch(UpdateInvestor(formData));
      } else {
        response = await dispatch(AddInvestor(formData));
      }
      if (response?.success === false || response?.status === false) {
        const errorMessage =
          response?.errors?.[0] ||
          response?.message ||
          response?.data?.message ||
          "Something went wrong!";

        toast.error(errorMessage);
      } else {
        console.log("response?.message", response);
        toast.success(response?.message || "Success!");
        navigate("/admin/investor"); // Redirect after success
      }
    },
    enableReinitialize: true,
  });

  console.log("formikformik", formik);
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Modal open handler
  const openModal = () => {
    setIsModalOpen(true);
  };

  const handleDelete = () => {
    closeModal();
  };

  const handleNext = async () => {
    try {
      const stepFieldMap = {
        1: Object.keys(validationSchemas[0].fields),
        2: Object.keys(validationSchemas[1].fields),
        3: Object.keys(validationSchemas[2].fields),
        4: Object.keys(validationSchemas[3].fields),
      };

      const fieldsToTouch = stepFieldMap[currentStep] || [];

      // Mark all fields in the current step as touched
      const touchedObj = {};
      fieldsToTouch.forEach((field) => {
        touchedObj[field] = true;
      });
      await formik.setTouched(touchedObj, true);

      // Validate and get the error object directly
      const errors = await formik.validateForm();

      // Check if any of the current step fields have errors
      const hasErrorsInStep = fieldsToTouch.some((field) => errors[field]);

      if (!hasErrorsInStep) {
        setCurrentStep((prevStep) => prevStep + 1);
      }
    } catch (error) {
      console.error("Validation failed:", error);
    }
  };

  // Function to handle the "Back" button
  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
      // setNomineeCount(1);
    }
  };

  // Function to get the step heading based on the current step
  const getStepHeading = (step) => {
    switch (step) {
      case 1:
        return (
          <div>
            <p className="step-heading">Step 1 of 4</p>
            <p className="step-label">Personal Details</p>
          </div>
        );
      case 2:
        return (
          <div>
            <p className="step-heading">Step 2 of 4</p>
            <p className="step-label">Bank Details</p>
          </div>
        );
      case 3:
        return (
          <div>
            <p className="step-heading">Step 3 of 4</p>
            <p className="step-label">FATCA Declaration</p>
          </div>
        );
      case 4:
        return (
          <div>
            <p className="step-heading">Step 4 of 4</p>
            <p className="step-label">Manage Nominees</p>
          </div>
        );
      default:
        return "";
    }
  };
  // Function to render the content for each step
  const renderStepContent = (step) => {
    switch (step) {
      case 1:
        return (
          <div>
            <PersonelDetails formik={formik} />
          </div>
        );
      case 2:
        return (
          <div>
            <BankDetails formik={formik} />
          </div>
        );
      case 3:
        return (
          <div>
            {/* FATCA Declaration Form */}
            <FatchDeclaration formik={formik} />
          </div>
        );
      case 4:
        return (
          <div>
            {/* Manage Nominees Form */}
            <ManageNominess
              formik={formik}
              nomineeCount={nomineeCount}
              setNomineeCount={setNomineeCount}
              noNominee={noNominee}
              setNoNominee={setNoNominee}
              soaNominee={soaNominee}
              setSoaNominee={setSoaNominee}
            />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <form
      noValidate
      onSubmit={(e) => e.preventDefault()}
      className="hello-form"
    >
      <div className="container-fluid page_background">
        {isLoading && (
          <div className="loader-overlay">
            <Loader />
          </div>
        )}
        <div className="page-inner-content mb-3">
          <div className="page_inner_content_box">
            {/* Main Heading */}
            <div style={{ display: "flex" }}>
              <Link
                style={{ marginBottom: "8px", marginTop: "3px" }}
                onClick={() => navigate(-1)}
              >
                <FontAwesomeIcon
                  icon={faAngleLeft}
                  className="color me-2"
                  style={{
                    fontSize: "24px",
                    color: "#2C2D3A",
                    paddingRight: "10px",
                  }}
                />
              </Link>

              <h5
                className="mb-4 main-heading-title"
                style={{ alignContent: "center", alignItems: "center" }}
              >
                {isEditing ? "Edit Investor" : "Add Investor"}
              </h5>
            </div>

            {/* Dynamic Step Heading */}
            <p
            // className="step-info"
            >
              {getStepHeading(currentStep)}
            </p>

            {/* Progress Bar */}
            <div className="mb-4">
              <div className="progress" style={{ height: "5px" }}>
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{ width: `${(currentStep / totalSteps) * 100}%` }}
                  aria-valuenow={(currentStep / totalSteps) * 100}
                  aria-valuemin={0}
                  aria-valuemax={100}
                ></div>
              </div>
            </div>

            {/* Card Content */}
            <div className="card redeam_bottom_card border-top-rounded">
              {renderStepContent(currentStep)}
            </div>

            {/* Navigation Buttons */}
            <div className="card-footer form_card form_card_border">
              <div className="d-flex justify-content-between gap-2">
                {currentStep > 1 && (
                  <button
                    type="button"
                    onClick={handleBack}
                    className="form_button"
                  >
                    Back
                  </button>
                )}
                {/* {currentStep === totalSteps ? (
                  <button
                    type="submit"
                    className="form_button next_btn"
                    onClick={(e) => {
                      e.preventDefault(); // Prevent default form submission
                      formik.handleSubmit();
                    }}
                  >
                    Submit
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={handleNext}
                    // className="form_button next_btn"
                    className={`form_button next_btn ${
                      currentStep === 1 ? "next-btn-right" : ""
                    }`}
                  >
                    Next
                  </button>
                )} */}
                <button
                  type="button"
                  className={`form_button next_btn ${
                    currentStep === 1 ? "next-btn-right" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    if (currentStep === totalSteps) {
                      formik.handleSubmit(); // Submit the form on the final step
                    } else {
                      handleNext(); // Move to the next step
                    }
                  }}
                  disabled={formik.isSubmitting} // Only disable during submit
                >
                  {currentStep === totalSteps ? "Submit" : "Next"}
                </button>

                {/* <button
                  type="button"
                  className={`form_button next_btn ${
                    currentStep === 1 ? "next-btn-right" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    if (currentStep === totalSteps) {
                      formik.handleSubmit(); // Submit the form on the final step
                    } else {
                      handleNext(); // Move to the next step
                    }
                  }}
                  disabled={!formik.isValid || formik.isSubmitting} // Disable if the form is invalid or submitting
                >
                  {currentStep === totalSteps ? "Submit" : "Next"}
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {isModalOpen && (
                <div className="modal show">
                  <div className="invester-popup">
                    <div className="modal-header invester-modal-header">
                      <h5 className="modal-title"></h5>

                      <IoMdClose
                        onClick={closeModal}
                        className="close-popup-color"
                        style={{ margin: "10px" }}
                      />
                    </div>

                    <div className="modal-body invester-modal-body">
                      <FaCircleCheck
                        fontSize="large"
                        className="invester-modal-icon"
                      />

                      <p>
                        Investor details Added <br /> successfully!
                      </p>
                    </div>

                    <div className="invester-modal-footer">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleDelete}
                      >
                        Ok
                      </button>
                    </div>
                  </div>
                </div>
              )} */}
    </form>
  );
};

export default AddInvestorForm;
